import { useEffect, useMemo, useState } from 'react';
import PbUmkuService from '../services/pbumku/PbumkuService';

const StatusChecklist = ({ kode }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    const [keterangan, setKeterangan] = useState('')

    useEffect(() => {
        const getStatusChecklist = async () => {
            const response = await pbumkuService.getStatusChecklistByStatusChecklist(kode)
            setKeterangan(response.data.keterangan)
        }
        getStatusChecklist()
    }, [pbumkuService, kode])

    return (
        <>
            {keterangan}
        </>
    )
}

export default StatusChecklist